import BreadCrumb from '../../../../components/breadcrumb';
import Header from '../../../../components/DashboardNavigation/header';
import Sidebar from '../../../../components/DashboardNavigation/sidebar';
import { NewsData } from '../../../../components/tables/news-tables/new';
import { useEffect, useState } from 'react';

import { News } from '@/src/data/types';
import { getAllNews } from '../../../../API/News/newsService';

const breadcrumbItems = [{ title: 'Actualités', link: '/admin-dashboard/actualités' }];
export default function NewsList() {
  const [news, setNews] = useState<News[]>([]);
  const fetchData = async () => {
    const response = await getAllNews();
    setNews(response?.news);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <NewsData data={news} />
        </div>
      </div>
    </>
  );
}
